import React from 'react';
import type { IconProps } from './types';

export const CompassIcon: React.FunctionComponent<IconProps> = ({ size = 20, fill = '#ffffff', ...props }) => {
	return (
		<>
			{/* 
        Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com 
        License - https://fontawesome.com/license/free 
        Copyright 2024 Fonticons, Inc.
      */}
			<svg
				xmlns='http://www.w3.org/2000/svg'
				viewBox='0 0 512 512'
				width={`${size}`}
				height={`${size}`}
				{...props}
			>
				<path
					fill={fill}
					d='M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm306.7 69.1L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
				/>
			</svg>
		</>
	);
};
